
import axios from 'axios'

const axiosDocument = axios.create({ baseURL: 'https://document.kanisius.sch.id:8000/api' })
// const axiosDocument = axios.create({ baseURL: 'http://192.168.100.177:8000/api' })
// const axiosDocument = axios.create({ baseURL: 'http://192.168.1.18:8000/api' })
const axiosPSB = axios.create({ baseURL: 'https://psbonline.kanisius.sch.id:8081/' })
const axiosUniv = axios.create({ baseURL: 'http://universities.hipolabs.com/' })

export { axios, axiosDocument, axiosPSB, axiosUniv }
